<template>
  <div id="cookie-policy-banner" :class="isVisible ? 'visible': ''">
    Questo sito usa cookie tecnici e di terze parti per migliorare l'esperienza e per profilare gli utenti. Per saperne di più e scoprire come disabilitarli, leggi la nostra 
    <router-link class="policy-banner" to="/cookies" target="_blank" rel="external noopener nofollow">cookie policy</router-link>.
    <a class="policy-banner" href="#0" @click.prevent="close">OK, accetto</a>.
  </div>
</template>

<script>
import Cookies from 'js-cookie';

export default {
  data() {
    return {
      isVisible: true
    }
  },
  methods: {
    close: function() {
      this.isVisible = false;
      Cookies.set('cookie-policy', 'accepted', {expires: 7});
    }
  },
  created() {
    this.isVisible = !(Cookies.get('cookie-policy') === 'accepted');
  }
}
</script>

<style scoped>
#cookie-policy-banner {
  display: none;
}

#cookie-policy-banner.visible {
  display: block;
}
</style>



// WEBPACK FOOTER //
// src/vue/components/CookieAlert.vue